module.exports = __webpack_public_path__ + "img/disconnect.3ec12f59.png";